import { MedicalItemType } from "./BodyPartsStats";
import Text from "../../../components/ui/Text";
import MedicalItemRow from "./MedicalItemRow";

interface Props {
  className?: string;
  medicalItems: MedicalItemType[];
  title?: string;
}

const MedicalItems = ({
  className = "",
  medicalItems = [],
  title = "Medical Things",
}: Props) => {
  return (
    <div className={`gilroy-font overflow-hidden ${className}`}>
      <Text className="text-white font-semibold text-right mb-2" size="xl">
        {title}
      </Text>

      <div className="overflow-y-scroll py-3 h-full pb-[4rem] scrollbar-1 space-y-4 pr-3">
        {medicalItems.map((item, i) => (
          <MedicalItemRow key={i} item={item} />
        ))}
      </div>
    </div>
  );
};

export default MedicalItems;
